'use strict';

const element = require('./element');
const userDetails = require('./userDetails');
const utils = require('../utils/utils');

function reportGotIt() {
  utils.reportBI('512');
  userDetails.setToLocalStorage('wixCookieNotification', 'approved');
  element.remove('cookieNotificationBannerWrapper');
}

function create(data, notificationBaeUrl, ts) {
  const locale = data.locale;
  const language = data.language;
  element.cssTag(`${notificationBaeUrl}assets/cookie-notification.css`);
  const bannerWrapper = element.create('div', 'cookieNotificationBannerWrapper');
  bannerWrapper.setAttribute('role', 'banner');
  const notificationText = element.create('p', 'cookieNotificationText');

  notificationText.setAttribute('tabIndex', '0');
  notificationText.innerHTML = locale['notification.message'];

  const moreInfo = element.create('a', 'cookieNotificationMoreInfo');
  moreInfo.text = locale['notification.more.info'];
  moreInfo.href = `http://${language === 'en' ? 'www' : language}.wix.com/about/privacy`;
  moreInfo.target = '_blank';
  moreInfo.setAttribute('role', 'button');
  moreInfo.addEventListener('click', () => {
    utils.reportBI('513');
  });

  const gotIt = element.create('a', 'cookieNotificationGotIt');
  gotIt.text = locale['notification.got.it'];
  gotIt.href = '#';
  gotIt.setAttribute('role', 'button');

  const gotItMobile = element.create('a', 'cookieNotificationGotItMobile');
  gotItMobile.text = locale['notification.got.it'];
  gotItMobile.href = '#';
  gotItMobile.setAttribute('role', 'button');


  gotItMobile.addEventListener('click', reportGotIt);
  gotIt.addEventListener('click', reportGotIt);

  const arrow = element.create('img', 'cookieNotificationArrow');
  arrow.src = `${notificationBaeUrl}assets/arrow1.svg`;
  arrow.alt = locale['notification.got.it.arrow'];
  arrow.setAttribute('aria-hidden', 'true');
  const arrowMobile = element.create('img', 'cookieNotificationArrow');
  arrowMobile.src = `${notificationBaeUrl}assets/arrow1.svg`;
  arrowMobile.alt = locale['notification.got.it.arrow'];
  arrowMobile.setAttribute('aria-hidden', 'true');

  element.append(element.bodyTag(), bannerWrapper);
  element.append(bannerWrapper, notificationText);

  element.append(gotIt, arrow);
  element.append(gotItMobile, arrowMobile);

  element.append(notificationText, moreInfo);
  element.append(notificationText, gotItMobile);
  element.append(bannerWrapper, gotIt);
  utils.reportBI('511', [`delta=${new Date().getTime() - ts}`]);

}

export {create};



// WEBPACK FOOTER //
// ./modules/visual.js